/**
 * API-клиент для публичных эндпоинтов — без X-Telegram-Init-Data.
 * Используется в PublicTournamentPage (открывается в обычном браузере).
 */

const API_BASE_URL = process.env.REACT_APP_API_URL || 'http://localhost:8080';

const publicRequest = async (endpoint) => {
  const response = await fetch(`${API_BASE_URL}${endpoint}`, {
    headers: { 'Content-Type': 'application/json' },
  });

  if (!response.ok) {
    let errorMessage = `Ошибка ${response.status}`;
    try {
      const data = await response.json();
      errorMessage = data.message || data.error || errorMessage;
    } catch {
      // ignore
    }
    const error = new Error(errorMessage);
    error.status = response.status;
    throw error;
  }

  return response.json();
};

/**
 * GET /api/public/tournaments/{token}
 * Возвращает TournamentResponse с canManage=false.
 */
export const getPublicTournament = (token) =>
  publicRequest(`/api/public/tournaments/${token}`);

/**
 * GET /api/public/tournaments/{token}/leaderboard[?stage=1|2]
 * Возвращает List<TournamentPlayerResponse> с полной статистикой.
 * @param {number} [stage] — только Beat the Box: таблица конкретного этапа
 *        (для свёрнутой истории этапа 1 во время этапа 2).
 */
export const getPublicLeaderboard = (token, stage) =>
  publicRequest(`/api/public/tournaments/${token}/leaderboard${stage != null ? `?stage=${stage}` : ''}`);

/**
 * SSE-подписка на изменения турнира.
 * Возвращает EventSource — вызывающий код отвечает за его закрытие.
 *
 * onUpdate(payload) — вызывается при каждом событии «update»,
 *   payload: { tournament: TournamentResponse, leaderboard: TournamentPlayerResponse[] }
 * onError() — вызывается при обрыве соединения (после чего EventSource переподключается сам).
 *
 * @returns {EventSource}
 */
export const subscribeTournamentStream = (token, onUpdate, onError) => {
  const url = `${API_BASE_URL}/api/public/tournaments/${token}/stream`;
  const es = new EventSource(url);

  es.addEventListener('update', (e) => {
    try {
      onUpdate(JSON.parse(e.data));
    } catch {
      // ignore malformed event
    }
  });

  if (onError) {
    es.onerror = onError;
  }

  return es;
};
